
import { NgModule } from '@angular/core';
import { ApiResourceModule } from 'libraries/service/apiResource/apiResource.module';
import { EnumsResourceService } from './enums-resource.service';

@NgModule({
    imports: [
        ApiResourceModule
    ],
    exports: [],
    declarations: [],
    providers: [
        EnumsResourceService
    ],
})
export class EnumsResourceModule { }
